import { capitalize } from "../util/helpers";
import {LanguageSearchDropdown } from '../util/language/languageSearchDropdown';
import {Mp3VersionsCombo, getFileUrl } from '../util/bible/bibleHelper';

FCBH.docReady(() => {
  const searchbar = document.getElementById("Search");
  const params = new URLSearchParams(window.location.search);
  const languageParam = params.get("language") ? capitalize(params.get("language")) : null
  const versionParam = params.get("version");
  const downloadReCaptchaId = "download-recaptcha";
  const downloadReCaptcha = document.getElementsByClassName("g-recaptcha")[0];
  downloadReCaptcha.id = downloadReCaptchaId;

  const container = document.querySelector("#mp3-version .w-dropdown-list");
  const copyrightNode = document.querySelector("#wf-form-MP3-Downloads .txt-notice");
  const textValueSelector = "#w-dropdown-toggle-0 div";
  const versionsCombo = new Mp3VersionsCombo({container, copyrightNode, textValueSelector, versionParam});
  versionsCombo.hideError = () => hideError();
  versionsCombo.printError = (msg) => showErrorWithMessage(msg);
  versionsCombo.setParams = () => setParams();
  versionsCombo.setVersion = (versionId) => setVersion(versionId);
  versionsCombo.onVersionRender = (isAvailable) => {
    document.querySelector(`#wf-form-MP3-Downloads > input[type='submit']`).disabled = !isAvailable;
  }
  
  addInputsWatchers();

  function setVersion(versionId) {
    const versionSelect = document.querySelector("#mp3-version .w-dropdown-list").childNodes;
    const index = versionSelect.length > 1 ? 1 : 0;
    versionsCombo.onVersionChange(versionSelect[index].id, versionSelect[index].textContent);
    if (languageSearchDropdown.searchbarComponent.value === languageParam) {
      const result = Array.from(versionSelect).filter(element => element.id == versionId);
      if(result) versionsCombo.onVersionChange(result[0].id, result[0].text);
    }
  }

  isLessThenIE10();

  //	Loads all the languages
  //	Also calls function that reads url to display version in url (if any)
  const languageSearchDropdown = new LanguageSearchDropdown({elementId: "language-search-dropdown", searchbarElId: "Search", listSelector: ".w-dropdown-list", languageParam})
  languageSearchDropdown.afterChange = (selectedLang, version) => versionsCombo.fetchVersions(selectedLang, version);

  function isLessThenIE10() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0) {
      // IE 10 or older => return version number
      var e = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
      if (e < 10) {
        document.getElementById("ie-error").style.display = "block";
      }
    }
  }

  function setParams() {
    const version = document.querySelector("#mp3-version .w-dropdown-toggle div").dataset.value
    const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?language=${searchbar.value}&version=${version}`;
    window.history.pushState({path:newurl},'',newurl);
  }

  async function onDownloadClicked(event) {
    hideError();
    const errors = [];

    const name = document.getElementById("mp3-name").value;
    const lastName = document.getElementById("Mp3-Last-Name").value;
    const email = document.getElementById("mp3-email").value;
    const recieveEmails = document.getElementById("Receive Email Updates").checked ? true : false;

    const textValue = document.querySelector("#w-dropdown-toggle-0 div");
    const damId = textValue.getAttribute("data-value");
    const i = Array.from(document.querySelectorAll("#mp3-version .w-dropdown-list a")).findIndex(
      (option) => option.id === damId
    );
    const v = versionsCombo.versions[i];
    let meta;
    try {
      meta = await getFileUrl(v);

    } catch (error) {
      console.error(error);
      errors.push("An error occurred. Please try again later.");
      showErrorWithMessage(errors);
      return;
    }
    if(!meta?.zip_file) {
      errors.push("This Audio Bible is not available for download. Try another version.");
      showErrorWithMessage(errors);
      return;
    }

    const response = grecaptcha.getResponse();
    if(response.length == 0) { 
      errors.push("Please confirm you're not a robot.");
      showErrorWithMessage(errors);
      return;
    }
    if (isTextEmpty(name) || isTextEmpty(email) || isTextEmpty(lastName)) {
      errors.push("Please fill out all form fields to download this Audio Bible.");
    }

    if (!atLeastOneLetter(name)) {
      errors.push("First Name can only contain letters and spaces.");
      event.preventDefault();
    }

    if (!atLeastOneLetter(lastName)) {
      errors.push("Last Name can only contain letters and spaces.");
      event.preventDefault();
    }

    if (!validEmail(email)) {
      errors.push("Email address is not valid.");
      event.preventDefault();
    }

    if (damId === "noVersion") {
      errors.push("Please select an audio bible version.");
    }

    if (i < 0) {
      console.log("COULDN'T FIND VERSION");
      errors.push("An error occurred. Please try again later.");
    }

    if (!v) {
      console.log("VERSION IS NOT TRUE");
      errors.push("An error occurred. Please try again later.");
    }

    if (errors.length > 0) {
      showErrorWithMessage(errors);
      event.preventDefault();
      return false;
    } else {

      const successContainer = document.querySelector(".w-form-done");
      const linkNode = successContainer.querySelector("a");
      const downloader = document.createElement("a");

      downloader.download = true;
      downloader.href = `${meta.zip_file}`;
      downloader.textContent = 'here';

      linkNode.parentNode.replaceChild(downloader, linkNode);

      successContainer.style.display = "block";
      downloader.click();

      const obj = {
        first_name: name,
        last_name: lastName,
        timestamp: Date.now().toString(),
        language: v.language.toString(),
        language_code: v.language_id.toString(),
        version_dam_id: v.filesets.id.toString(),
        version_name: v.vname,
        email: email.toLowerCase(),
        recieve_emails: recieveEmails,
      };
      try { 
        // send to firebase
        FCBH.firebaseDb
          .collection("audioBibleDownloads")
          .add(obj)
          .then(function (docRef) {
            console.log("DOCUMENT WAS SENT");
          })
          .catch(function (error) {
            console.error("Error adding document: ", error);
            console.log("ERROR: DOCUMENT WAS NOT SENT");
          });

        if (!recieveEmails) {
          document.getElementById("wf-form-MP3-Downloads").style.display = 'none';
          event.preventDefault();
        }

      } catch (error) {
        console.error(error);
        errors.push("An error occurred. Please try again later.");
      }

      window.scrollTo(0,0);
    }
  }

  function showErrorWithMessage(messages) {
    const messageContainer = document.querySelector(".w-form-fail");
    const text = messageContainer.querySelector("div");
    messageContainer.style.display = "block"; 
    let message;
    if (Array.isArray(messages)) {
      message = `${messages.join("<br/>")}`;
    } else {
      message = messages;
    }
    text.innerHTML = message;
  }

  function hideError() {
    const messageContainer = document.querySelector(".w-form-fail");
    messageContainer.style.display = "none";
  }
  

  function isTextEmpty(text) {
    return text.trim() == "";
  }

  function lettersOnly(text) {
    const t = text.trim();
    const regex = /^[\p{L} \s.-]*$/u
    return regex.test(t);
  }

  function atLeastOneLetter(text) {
    const t = text.trim();
    const regex = /[a-zA-Z]/;
    return regex.test(t);
  }

  function validEmail(text) {
    var t = text.trim();
    var letters = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return t.match(letters) ? true : false;
  }

  function addInputsWatchers(){
    const inputIds = ["Mp3-Last-Name", "mp3-name"];

    inputIds.forEach(inputId => {
      document.getElementById(inputId)
        .addEventListener("keyup", checkAllowedText )
    });
  }

  function checkAllowedText({ target }){
    if(! lettersOnly(target.value)) target.value = target.value.replace(/[^\p{L} \s.-]+/gu, "");
  }

  document.getElementById("wf-form-MP3-Downloads").addEventListener("submit", (e) =>  onDownloadClicked(e));
  document.querySelectorAll(`#wf-form-MP3-Downloads input[type='submit']`).forEach((button) => {
    button.addEventListener("click", (e) =>  onDownloadClicked(e));
  });
});
 
